<template>
    <v-container>
      <template>
        <div class="text-center">
            <v-dialog
                v-model="dialog"
                width="800"
                @click:outside="closeModal"
                :retain-focus="false"
                persistent
            >
            <v-card class="" rounded="0" >
              <v-toolbar flat color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">{{
                  $t("Add New Record")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="py-5">
                <v-row  >
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">
                            {{ $t("animal.conceptionInfo.deliveryDate") }}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" size="20">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span>{{ $t("animal.conceptionInfo.deliveryDateH") }}</span>
                            </v-tooltip>
                        </label>
                        <v-menu
                            v-model="showDeliveryCheck"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="animal.deliveryDate"
                                append-icon="mdi-calendar"
                                outlined
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :placeholder="$t('animal.conceptionInfo.selectDate')"
                                @click:append="showDeliveryCheck = true"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="animal.deliveryDate"
                                @input="showDeliveryCheck = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label
                            class="subtitle-2 black--text text-no-wrap"
                        >
                            {{ $t("animal.conceptionInfo.calfId") }}
                        <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="20">
                                mdi-information-outline
                            </v-icon>
                            </template>
                            <span>{{ $t("animal.conceptionInfo.calfIdH") }}</span>
                        </v-tooltip>
                        </label>
                        <v-text-field
                            type="text"
                            outlined
                            placeholder="e.g. 123"
                            dense
                            v-model="animal.calfId"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label
                            class="subtitle-2 black--text text-no-wrap"
                        >
                            {{ $t("animal.birthFarm") }}
                        <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="20">
                                mdi-information-outline
                            </v-icon>
                            </template>
                            <span>{{ $t("animal.birthFarm") }}</span>
                        </v-tooltip>
                        </label>
                        <v-text-field
                            type="text"
                            outlined
                            :placeholder="$t('unit')"
                            dense
                            v-model="animal.birthFarm"
                        ></v-text-field>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label
                            class="subtitle-2 black--text text-no-wrap"
                        >
                            {{ $t("animal.birthEase") }}
                        <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="20">
                                mdi-information-outline
                            </v-icon>
                            </template>
                            <span>{{ $t("animal.conceptionInfo.birthEaseH") }}</span>
                        </v-tooltip>
                        </label>
                        <v-select
                            :items="birthEaseTypes"
                            item-text="name"
                            item-value="id"
                            outlined
                            :placeholder="$t('animal.conceptionInfo.selectBirthEase')"
                            dense
                            v-model="animal.birthEaseOptId"
                        ></v-select>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label
                            class="subtitle-2 black--text text-no-wrap"
                        >
                            {{ $t("animal.conceptionInfo.birthDayOldWeight") }}
                        <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="20">
                                mdi-information-outline
                            </v-icon>
                            </template>
                            <span>{{ $t("animal.conceptionInfo.birthDayOldWeightH") }}</span>
                        </v-tooltip>
                        </label>
                        <div class="d-flex">
                            <v-text-field
                                type="number"
                                outlined
                                dense
                                placeholder="e.g. 123"
                                v-model="animal.birthWeight"
                                min="0"
                            ></v-text-field>
                            <v-select
                                :items="['kg','lbs']"
                                outlined
                                class="ml-4"
                                placeholder="Unit"
                                dense
                                v-model="animal.birthWeightUom"
                                error-messages=""
                                :rules="[(v) => !!v || $t('animal.conceptionInfo.selectUnit')]"
                            ></v-select>
                        </div>
                    </v-col>
                </v-row>
                <hr>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined n-width="50px" @click="closeModal">Cancel</v-btn>
                    <v-btn color="primary" min-width="50px" @click="registerConception">Submit</v-btn>
                </v-card-actions>
            </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <DataLostWarning
        :dialogI="dataLossWarning"
        v-if="dataLossWarning"
        @closeDialog="closeWarningMessage"
        @saveData="closeWarningMessage"
      ></DataLostWarning>
    </v-container>
  </template>
  
  <script>
  import loadingMixin from "@/mixins/LoadingMixin";
  import generalMixin from "@/mixins/GeneralMixin";
  import GeneralService from "@/_services/GeneralService";
  import AnimalService from "@/_services/AnimalService";

  export default {
    created() {
        this.assignValue()
        const fetchData = async () => {
        GeneralService.getDropdownData({
            options: ["conception-method", "birth-ease"],
        })
            .then((res) => {
            this.conceptionMethods = res.data["conception-method"];
            this.birthEaseTypes = res.data["birth-ease"];
            })
            .catch((err) => console.log("err", err));
        };
        fetchData();
    },
    computed: {
      dialog() {
        return this.dialogI;
      },
    },
    data() {
      return {
        birthEaseTypes: [],
        showDeliveryCheck: false,
        conceptionMethods: [],
        dataLossWarning: false,
        animal: {
            animalNumber: this.$route.params.animal_number,
            deliveryDate: "", //(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            calfId: "",
            birthFarm: "",
            birthEaseOptId: "",
            birthWeight: "",
            birthWeightUom: "kg",
        },
      };
    },
    methods: {
        assignValue() {
            this.animal.id = this.editedItem.id
            this.animal.deliveryDate = this.editedItem.deliveryDate
            this.animal.calfId = this.editedItem.calf
            this.animal.birthFarm = this.editedItem.birthFarm
            this.animal.birthEaseOptId = this.editedItem.birthEaseId
            const b = this.editedItem.birthWeight.split(" ");
            this.animal.birthWeight = b[0]
            this.animal.birthWeightUom = b[1]
            console.log(this.editedItem)
        },
      closeWarningMessage(res) {
        this.dataLossWarning = false;
        if (!res) {
          this.$emit("closeAddUser");
        }
      },

      closeModal() {
        this.dataLossWarning = true;
      },
      registerConception() {
        let isEmpty = true
        Object.entries(this.animal).forEach(([key, value]) => {
            if(key != 'animalNumber' && value != ""){
                isEmpty = false
                // console.log(key, value)
            }
        })

        if(isEmpty){
            this.$notify({
                title: this.$t('Nothing to add'),
                type: "error"
            });
            return;
        }
        this.startLoading();
        this.formChanged = false;
        AnimalService.updateAnimalConception(this.animal, 'birth')
            .then((res) => {
            if (res.success) {
                this.$notify({
                title: this.$t('animal.conceptionInfo.animalConceptionAddedSuccessfully'),
                text: res.message,
                type: "success",
                position: "top right",
                });
            } else {
                this.$notify({
                title: this.$t('somethingWentWrong'),
                text: res.message,
                type: "error",
                position: "top right",
                });
            }
            this.$emit('added')
            this.stopLoading();
            })
            .catch((err) => {
            console.log(err.data);
            this.stopLoading();
            });
    },
  
    },
    props: {
      dialogI: {
        type: Boolean,
        required: true,
      },
      editedItem: {
        type: Object,
        required: true
      }
    },
    mixins: [loadingMixin, generalMixin],
  };
  </script>
  
  <style>

  </style>
  